import React, { useEffect, useState, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useNavigate } from 'react-router-dom';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './genre-list.scss';

const CountryList = () => {
    const navigate = useNavigate();
    const swiperRef = useRef(null);
    const [countries, setCountries] = useState([]);
    const [isBeginning, setIsBeginning] = useState(true);
    const [isEnd, setIsEnd] = useState(false);

    useEffect(() => {
        fetch('/movies-settings-api.php')
            .then(r => r.json())
            .then(d => {
                if (!d.success) return;
                const row = d.data.find(r => r.setting_key === 'country_list');
                if (row?.setting_value) {
                    try { setCountries(JSON.parse(row.setting_value)); } catch {}
                }
            })
            .catch(() => {});
    }, []);

    const updateNav = (swiper) => {
        setIsBeginning(swiper.isBeginning);
        setIsEnd(swiper.isEnd);
    };

    if (!countries.length) return null;

    return (
        <div className="genre-list">
            {!isBeginning && (
                <button className="gl-nav gl-nav--prev" onClick={() => swiperRef.current?.slidePrev()}>
                    <FaChevronLeft />
                </button>
            )}
            {!isEnd && (
                <button className="gl-nav gl-nav--next" onClick={() => swiperRef.current?.slideNext()}>
                    <FaChevronRight />
                </button>
            )}
            <Swiper
                grabCursor={true}
                spaceBetween={16}
                slidesPerView="auto"
                onSwiper={(s) => { swiperRef.current = s; updateNav(s); }}
                onSlideChange={updateNav}
            >
                {countries.map((c, i) => (
                    <SwiperSlide key={i}>
                        <div
                            className="gl-card"
                            style={{ background: c.gradient }}
                            onClick={() => navigate(`/search/country/${encodeURIComponent(c.name)}`)}
                        >
                            <span className="gl-card__name">{c.name}</span>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default CountryList;
